<template>
  <div :style="{ minHeight: height + 'px' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped></style>
